import { action, observable } from "mobx";
import { getRequest } from "../utils/RestMiddlewareUtil";

// "Last Minute Buys" rail on the cart page (v16/cart/last-minute-buys).
// Not persisted: fetched on every cart open and when the vendor changes.
class LastMinuteBuysStore {
  @observable all = [];
  @observable state = "pending";
  @observable fetchState = "pending";

  @action
  cancelPromise(callee) {
    if (this[callee + "Promise"]) {
      this[callee + "Promise"].cancel();
    }
    this[callee + "State"] = "pending";
  }

  // productIds: cart product ids (`id`, not `vendor_product_id`)
  @action
  fetch = (vendorId, productIds = []) => {
    this.cancelPromise("fetch");
    if (!vendorId) {
      this.all = [];
      return;
    }
    this.fetchState = "fetching";

    const exclude = productIds
      .map(id => `&exclude_product_ids[]=${encodeURIComponent(id)}`)
      .join("");

    this.fetchPromise = getRequest(
      this,
      `v16/cart/last-minute-buys?vendor_id=${vendorId}${exclude}`,
      data => {
        this.all = Array.isArray(data) ? data : [];
        this.fetchState = "done";
      },
      () => {
        this.all = [];
        this.fetchState = "fail";
      },
      () => {
        this.all = [];
        this.fetchState = "error";
      }
    );
  };

  @action
  remove = productId => {
    this.all = this.all.filter(product => product.id !== productId);
  };

  @action
  cancel = () => {
    this.state = "pending";
    this.cancelPromise("fetch");
  };
}

const lastMinuteBuysStore = new LastMinuteBuysStore();
export default lastMinuteBuysStore;
